import React, { useState } from "react";
import { FaInfinity } from "react-icons/fa";
import { RiShareBoxLine } from "react-icons/ri";
import PricingPlanPopup from "./pricingPpup";
import { useStores } from "../../../store";

const PricingCard = ({
  id,
  key,
  title,
  discription = "",
  price,
  interviews,
  resumeScreening,
  jobPostings,
  isSelected,
  handleClick,
  interviewLabel,
  resumeScreeningLabel,
  jobPostingsLabel,
  monthPrice,
  duration,
}) => {
  const { RecuiterStore } = useStores();
  const [popUpInitialValue, setPopUpInitialValue] = useState(false);
  // alert(price, id);
  return (
    <div
      onClick={handleClick}
      className={`border-2 p-4 rounded-lg md:rounded-2xl  md:w-[27vw] lg:w-[26vw] w-full  cursor-pointer transition-colors ${
        isSelected ? "bg-[#FFE7D6] border-primary" : "bg-white "
      }`}
      key={key}
    >
      <PricingPlanPopup
        popUpInitialValue={popUpInitialValue}
        handlePopup={() => {
          setPopUpInitialValue(false);
        }}
      />
      <div className="flex items-center justify-between md:mb-4">
        <div className="flex items-center">
          <div className="p-2 mt-2 relative">
            <input
              type="radio"
              name="audioAvatar"
              className="relative h-5 w-5 cursor-pointer appearance-none rounded-full border-2 border-gray-300 transition-all duration-300 ease-in-out
              before:absolute before:top-1/2 before:left-1/2 before:-translate-x-1/2 before:-translate-y-1/2 before:h-2.5 before:w-2.5 before:rounded-full before:bg-primary before:opacity-0 before:transition-opacity before:duration-300 before:ease-in-out
              checked:border-primary checked:before:opacity-100 hover:border-primary/70
              focus:outline-none focus:ring-2 focus:ring-primary/20"
              checked={isSelected}
              readOnly
            />
            {/* <span className="absolute bg-gray-300 w-2 h-2 rounded-full peer-checked:bg-primary peer-checked:opacity-100 top-[1.15rem] left-4 transform -translate-x-1/2 -translate-y-1/2"></span> */}
          </div>
          <h2
            className={`md:text-xl text-base   gil-med flex-grow whitespace-nowrap ${
              isSelected && "gil-bold"
            }`}
          >
            {title}
          </h2>
          {/* {price ? (
            <a
              className=""
              onClick={(e) => {
                e.stopPropagation();
                setPopUpInitialValue(true);
              }}
            >
              <RiShareBoxLine className="text-primary ml-1 md:ml-4 md:text-xl" />
            </a>
          ) : null} */}
        </div>

        <p className="text-primary relative text-3xl font-bold">
          {price !== 0 && duration === 1 ? `₹${price.toLocaleString('en-IN')}` : ``}
          {price !== 0 && duration === 12 ? `₹${monthPrice.toLocaleString('en-IN')}` : ``}
          {id === 2 && isSelected && `₹${RecuiterStore.paymentTotal.toLocaleString('en-IN')}`}
          {id !== 2 && (
            <span className="text-xs text-gray-500">/per month</span>
          )}
          <span className=" text-gray-500 absolute -bottom-5 md:-bottom-6 text-[11px] left-0">
            {duration === 12 && `Billed annually at ₹${price.toLocaleString('en-IN')}`}
          </span>
        </p>
      </div>
      {discription === "" ? (
        <div className="md:text-[12px] text-xs mb-2 text-[#808080] flex justify-between">
          <p className="flex">
            {interviewLabel.includes("AI ") ? interviewLabel.replace("AI ", "") : interviewLabel}:{" "}
            <span className="font-semibold text-primary">
              {interviews ? (
                interviews < 10 ? (
                  `0${interviews}`
                ) : interviews === "∞" ? (
                  <FaInfinity />
                ) : (
                  interviews
                )
              ) : (
                RecuiterStore.selectedInterviewsCount
              )}
            </span>
          </p>
          <p className="flex">
            {resumeScreeningLabel.includes("AI ") ? resumeScreeningLabel.replace("AI ", "") : resumeScreeningLabel}:{" "}
            <span className="font-semibold text-primary">
              {resumeScreening
                ? resumeScreening < 10
                  ? `0${resumeScreening}`
                  : resumeScreening
                : RecuiterStore.selectedResumeAnalyzerCount}
            </span>
          </p>
          <p className="flex justify-between">
            {jobPostingsLabel}:{" "}
            <span className="font-semibold text-primary">
              {jobPostings
                ? jobPostings < 10
                  ? `0${jobPostings}`
                  : jobPostings
                : RecuiterStore.selectedJobPostsCount}
            </span>
          </p>
        </div>
      ) : (
        <p className="text-[15px] text-black">{discription}</p>
      )}
    </div>
  );
};

export default PricingCard;
